import Vue from 'vue';
import CatalogPage from '@/classes/catalog-page';
import Catalog from '@/classes/catalog';

const defaultState = {
  catalog: null,
  catalogPages: {},
};

const defaultGetters = {
  get: (state) => state.catalog,
  pages: (state) => state.catalogPages,
  pageList: (state) => Object.keys(state.catalogPages).map(id => state.catalogPages[id]),
};

const mutations = {
  set: function(state, catalog) {
    if (catalog) {
      state.catalog = new Catalog(catalog);
    }
  },
  setPages: function(state, catalogPages = []) {
    catalogPages.forEach(page => {
      Vue.set(state.catalogPages, page.id, new CatalogPage(page));
    });
  },
};

export default {
  namespaced: true,
  state: defaultState,
  getters: defaultGetters,
  mutations,
};
